import React, { useState } from 'react';
import { useStripe, useElements, IdealBankElement } from '@stripe/react-stripe-js';

import IdealBankSection from './IdealBankSection';
import axios from "axios";
import BaseUrl from "../BaseUrl"
export default function CheckoutForm({ amount }) {
    const [loading, setLoading] = useState(false)
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {

        setLoading(true)
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
            setLoading(false)
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        const idealBank = elements.getElement(IdealBankElement);

        // For brevity, this example is using uncontrolled components for
        // the accountholder's name. In a real world app you will
        // probably want to use controlled components.
        // https://reactjs.org/docs/uncontrolled-components.html
        // https://reactjs.org/docs/forms.html#controlled-components

        const accountholderName = event.target['accountholder-name'];


        /**************************/
        const token = localStorage.getItem("authorization")
        var auth = {
            headers: {
                authorization: `bearer ${token}`,
            }
        };
        const url = BaseUrl() + "api/user/stripePaymentDetail"
        const data = {
            "amount": amount
        }

        try {
            const response = await axios.post(url, data, auth);
            if (response.status === 200) {
                console.log(response.data.Response.stripePayment.client_secret)
                const { error } = await stripe.confirmIdealPayment(response.data.Response.stripePayment.client_secret, {
                    payment_method: {
                        ideal: idealBank
                    },
                    return_url: window.location.href,
                });

                if (error) {
                    setLoading(false)
                    // Show error to your customer.
                    console.log(error.message);
                }

                // Otherwise the customer will be redirected away from your
                // page to complete the payment with their bank.
            }
            else {
                console.log(response.data.message);
            }
        } catch (error) {
        }
        /**************************/

    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-row">
                <IdealBankSection />
            </div>
            <button type="submit" disabled={!stripe || loading} className=" w-full text-white bg-[#2557D6] hover:bg-[#2557D6]/90 focus:ring-4 focus:ring-[#2557D6]/50 focus:outline-none font-medium text-sm text-center inline-block items-center dark:focus:ring-[#2557D6]/50 mr-2 mb-2" style={{ "font-size": "16px", "height": "45px", "border-radius": "0.2rem" }}>
                Submit Payment  {loading &&
                    <div role="status">
                        <svg aria-hidden="true" class="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                    </div>
                }
            </button>
        </form>
    );
}